import { Box, InlineStack, Page, Spinner } from "@shopify/polaris";

export default function PageLoading({
  fullWidth = false,
}: {
  fullWidth?: boolean;
}) {
  return (
    <Page fullWidth={fullWidth}>
      <div className="crmPageLoading">
        <Box paddingBlockStart="1600" paddingBlockEnd="1600">
          <InlineStack align="center">
            <Spinner accessibilityLabel="Loading" size="large" />
          </InlineStack>
        </Box>
      </div>
    </Page>
  );
}
